module.exports = __webpack_public_path__ + "4ed95097df676a5b5a8ba446632b9917.svg";